import React from 'react';
import SmallCommentContainer from '../../components/Utils/SmallComments/SmallCommentContainer';
import {Link} from 'react-router-dom';
import {message, Popover, Slider} from 'antd';
import agent from '../../agent';
import PostPreviewUrl from '../Utils/PostPreviewUrl';
import {connect} from 'react-redux';
import {ABUSE, POST_FAVORITED, POST_UNFAVORITED} from '../../constants/actionTypes';
import moment from 'moment';
import PostAvatar from './PostAvatar'
import PostImage from './PostImage'
import {getLabel} from "../../language";
import PostShowModel from "../Common/PostShowModel";
import ImportantImage from "../../images/important.svg"
import TrustImage from "../../images/trust.svg"
import PositiveImage from "../../images/positive.svg"
import RelevantImage from "../../images/relevant.svg"
import commentImage from "../../images/comments-filled-blue.svg"

const todayDate = moment().format('YYYY-MM-DD');

const mapStateToProps = (state, ownProps) => {
    return {
        anonymousMode: state.user.anonymousMode
    }
}

const mapDispatchToProps = dispatch => ({
    favorite: slug => dispatch({
        type: POST_FAVORITED,
        payload: agent.Posts.favorite(slug)
    }),
    unfavorite: slug => dispatch({
        type: POST_UNFAVORITED,
        payload: agent.Posts.unfavorite(slug)
    }),
    abuse: payload => dispatch({
        type: ABUSE,
        payload: agent.Abuse.setAbuse(payload)
    })
});

class PostPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            userData: '',
            Important: null,
            Trust: null,
            Interesting: null,
            Positive: null,
            reaction: [],
            showComments: false,
            visible: {
                Important: false,
                Trust: false,
                Interesting: false,
                Positive: false,
                reaction: false
            }
        }
    }

    componentDidMount() {
        if (Array.isArray(this.props?.post?.interactions?.myInteractions)) {
            this.props.post.interactions.myInteractions.map((item) => {
                this.setState({
                    [item.interactionType]: item.points
                })
            })
        }
        if (Array.isArray(this.props?.post?.abuse?.myAbuse)) {
            const react = this.state.reaction;
            this.props.post.abuse.myAbuse.map((item) => {
                if (!react.includes(item.abuseType)) {
                    react.push(item.abuseType)
                    this.setState({
                        reaction: react
                    })
                }
            })
        }
    }

    openModel = (data) => {
        if(this.props?.currentUser){
            this.setState({
                isOpen: !this.state.isOpen,
                userData: data
            })
        }else{
            this.props.history.push(`/login`)
        }
    }

    onChange = async (key, value) => {
        if(this.props.currentUser){
            this.setState({
                [key]: value
            })
        }else{
            this.props.history.push(`/login`)
        }
        // this.setState(prevState => ({
        //     visible: {
        //         ...prevState.visible,
        //         [key]: false
        //     }
        // }))
    }

    handleReaction = (name, post) => {
        if (!this.state.reaction.includes(name)) {
            this.setState(prevState => ({
                reaction: [
                    ...prevState.reaction,
                    name
                ]
            }))
        }
        this.props.abuse({
            "EntityId": post.id,
            "EntityType": "Post",
            "AbuseType": name,
            "AuthorId": post.author.id,
        });
    };

    GetInteractionValue = (name) => {
        return this.props.post.interactions?.myInteractions.find(item => item.interactionType == name)?.points?.toString()
    }

    onPopOverClose = async (key, value) => {
        const body = {
            EntityId: this.props.post.id,
            EntityType: "Post",
            AuthorId: this.props.post.author.id,
            InteractionType: key,
            Points: Number(value)
        };

        await agent.Interactions.setInteraction(body).then(res => {
            console.log({res})
        }).catch(err => console.log('Oh no!', err));
    };

    openPopOver = (key) => {
        this.setState(prevState => ({
            visible: {
                ...prevState.visible,
                [key]: true
            }
        }))
    };

    getClassName = (value) => {
        let className = "neutral";

        // if (value === 2 || value === 1) {
        //     className = "good"
        // } else if (value === 0) {
        //     className = "neutral"
        // } else if (value === -1 || value === -2) {
        //     className = "bad"
        // }

        return className
    }

    handleVisibleChange = (key, visible) => {
        this.setState(prevState => ({
            visible: {
                ...prevState.visible,
                [key]: visible
            }
        }))
    };

    handleReportAbuse = () =>{
        if(this.props?.currentUser){
            message.error(getLabel(338));
        }else{
            this.props.history.push(`/login`)
        }
    }

    render() {
        const {Important, Trust, Interesting, Positive, reaction} = this.state;
        const post = this.props.post || {};
        const mayReportAbuse = this.props?.currentUser?.user_privilege?.mayReportAbuse
        if (!post.author) {
            return null
        }
        // const canModify = this.props.currentUser && this.props.currentUser.id &&
        //     parseInt(this.props.currentUser.id) === parseInt(post.author.id);
        const postDate = post.published !== null ? moment(new Date(post.published)).format('YYYY-MM-DD') : null;

        const getDisplayNameFromMentions = (userName) => {
            if (this.props.mention && this.props.mention.mentions) {
                const mentionUser = this.props.mention.mentions.find(res => res.id == userName);
                return (mentionUser && mentionUser.display && mentionUser.display) || userName;
            }
            return userName;
        }

        const getCommentsById = (postId) => {
            if (this.props.commentsList && Object.keys(this.props.commentsList).length !== 0 && !this.props.commentsList.hasError && postId) {
                return this.props.commentsList.filter(item => item?.postId === postId).sort((firstComment, secondComment) => {
                    return firstComment.dateCreated < secondComment.dateCreated ? -1 : 1
                });
            }
        };

        const parseBody = body => {
            var matchedMentions = body.match(/\[(.*?)\]/g);
            let content = body;
            if (matchedMentions && matchedMentions.length > 0) {
                matchedMentions.map(res => {
                    const userName = res.replace(/[\[\]']+/g, '');
                    const replaceFrom = `@[${userName}](${userName})`;
                    const displayName = getDisplayNameFromMentions(userName);
                    content = content.replace(replaceFrom, `<a href=/@${userName}>${displayName}</a>`);
                })
            }
            content = content.replace(/\n/g, "<br/>");
            content = content.replace(/  /g, "&nbsp;&nbsp;");
            // content = content.replace(/(https?:\/\/[^\s]+)/g, "<a href='$1' target='_blank'>$1 </a>")
            content = content.replace(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g, "<a href='$&' target='_blank'>$& </a>")

            return {__html: content};
        };

        return (
            <div className="posts-content">
                <article className={`${this.props.anonymousMode ? "post-preview-dark" : ""}`}>
                    <header className={this.props.dropDown && 'open'}>
                        <div className="row">
                            <div className="post-header-content">
                                <div className={`${this.props.editable ? 'col-md-6' : 'col-md-12'}`}>
                                    <div className="authorimage m-0"><a className="politician">
                                        <PostAvatar userName={post.author.userName} isAnonymous={post.anonymous}/>
                                        <span
                                            className={post.author?.isVerified ? "gender verified" : `${parseInt(post.author.gender) === 1 && "female "}${parseInt(post.author.gender) === 2 && " male"}`}/>
                                    </a></div>
                                    <Link className="link-to-post"
                                          to={post.status ? 'posts/' + post.slug : '/editor/' + post.slug}>
                                        <div className="articletitle">
                                            <h5 className={`m-b-5 ${this.props.anonymousMode ? "post-title-dark" : ""}`}>
                                                {post.title}
                                            </h5>
                                            {
                                                post.anonymous ?
                                                    <div className="author"><Link to="">{getLabel(315)}</Link></div> :
                                                    <div className="author">{getLabel(170)} {<Link
                                                        to={`/@${post.author && post.author.userName}`}>{post.author.displayName}, {post.author.displayLocation}</Link>}</div>
                                            }
                                            <div className="date">
                                                {moment(todayDate).isSame(postDate) ?
                                                    moment(new Date(post.published)).format('LT')
                                                    :
                                                    postDate ? new Date(post.published).toDateString() : 'Saved as draft on ' + new Date(post.updated).toDateString()
                                                }
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="facebook-reaction col-md-1">
                                   {mayReportAbuse ? <span className="like-btn">
                                        <span
                                            className="like-btn-text">Abuse?</span>
                                            <ul className={`${this.props.anonymousMode ? "reactions-box-dark" : "reactions-box"}`}>
                                                    <span className="reaction reaction-vulgar" onClick={() => {
                                                        this.handleReaction("Vulgar", post)
                                                    }} data-reaction="Vulgar"/>
                                                    <span className="reaction reaction-irrelevant" onClick={() => {
                                                        this.handleReaction("Irrelevant", post)
                                                    }} data-reaction="Irrelevant"/>
                                                    <span className="reaction reaction-pointless" onClick={() => {
                                                        this.handleReaction("Pointless", post)
                                                    }} data-reaction="Pointless"/>

                                            </ul>
                                        </span> : <span className="like-btn-text" onClick={()=>this.handleReportAbuse()}>Abuse?</span>}
                                    <div className="like-stat">
                                        <span className="like-emo">{reaction && reaction.map((item) => (
                                            <span className={`like-btn-${item || ""}`}/>))}</span> <span
                                        className="like-details"/>
                                    </div>
                                </div>
                                {this.props.editable &&
                                <div className="col-md-6">
                                    <Link to={post.status ? 'posts/' + post.slug : '/editor/' + post.slug}
                                          className="btn btn-primary btn-sm m-r-5">{post.status ? getLabel(171) : getLabel(172)}</Link>
                                    <a onClick={() => this.props.onRemovePost(post.id)}
                                       className="btn btn-primary btn-sm m-r-5">{getLabel(131)}</a>
                                    <Link to={'/editor/' + post.slug}
                                          className="btn btn-primary btn-sm m-r-5">{getLabel(130)}</Link>
                                </div>
                                }
                            </div>
                        </div>
                    </header>
                    {
                        post.images && post.images.map((img) => {
                            return (<div key={img.id} className="text-center"><PostImage imageId={img.id}/></div>)
                        })
                    }
                    {
                        post.body !== undefined &&
                        <div className="preview-link text-wrap" dangerouslySetInnerHTML={parseBody(post.body)}/>
                    }

                    {post.body !== undefined &&
                    <PostPreviewUrl parseUrlAsync={agent.PreviewUrl.get} value={post.body}/>}
                    {(!Important && Important != 0 && this.props.index === 0) &&
                    <div className="text-danger font-12">no one will see your ratings - they are purely to reward
                        quality on the site and improve your own experience</div>}
                    <div className="additional justify-content-between" style={{display: "flex"}}>
                        <div className="buttonlist row pull-right">

                            <div className="dropdown m-b-5">
                                <Popover trigger="click" visible={this.state.visible.Important}
                                         content={
                                             <div>
                                                 <h5 className="font-12 font-normal m-0">IMPORTANCE</h5>
                                                 <Slider
                                                     vertical
                                                     min={-2}
                                                     max={2}
                                                     value={Important || 0}
                                                     className="vertical-slider-blue"
                                                     onChange={(value) => this.onChange("Important", value)}
                                                     onAfterChange={(value) => this.onPopOverClose("Important", value)}
                                                     tooltipVisible={false}
                                                 />
                                                 <h6 style={{marginTop: 20}}>{Important}</h6>
                                             </div>
                                         }
                                         onVisibleChange={(value) => this.handleVisibleChange("Important", value)}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-icon btn-toolbar dropdown-toggle button-hover"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                        onClick={() => this.openPopOver("Important")}
                                    >
                                        <img src={ImportantImage}/>
                                    </button>
                                </Popover>

                                <div className="buttonvalue" id="importancevalue">
                                    <span
                                        // className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Important)}`}>{Important?.toString() || this.GetInteractionValue("Important") || "Important"}</span>
                                        className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Important)}`}>Important</span>
                                </div>
                            </div>

                            <div className="dropdown m-b-5">
                                <Popover trigger="click" visible={this.state.visible.Trust}
                                         content={
                                             <div>
                                                 <h5 className="font-12 font-normal m-0">TRUST</h5>
                                                 <Slider
                                                     vertical
                                                     min={-2}
                                                     max={2}
                                                     className="vertical-slider-blue"
                                                     value={Trust || 0}
                                                     onChange={(value) => this.onChange("Trust", value)}
                                                     onAfterChange={(value) => this.onPopOverClose("Trust", value)}
                                                     tooltipVisible={false}
                                                 />
                                                 <h6 style={{marginTop: 20}}>{Trust}</h6>
                                             </div>
                                         }
                                         onVisibleChange={(value) => this.handleVisibleChange("Trust", value)}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-icon btn-toolbar dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                        onClick={() => this.openPopOver("Trust")}
                                    >
                                        <img src={TrustImage}/>
                                    </button>
                                </Popover>

                                <div className="buttonvalue" id="trustvalue">
                                    <span
                                        // className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Trust)}`}>{Trust?.toString() || this.GetInteractionValue("Trust") || "Trust"}</span>
                                        className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Trust)}`}>Trust</span>
                                </div>
                            </div>

                            <div className="dropdown m-b-5">
                                <Popover trigger="click" visible={this.state.visible.Positive}
                                         content={
                                             <div>
                                                 <h5 className="font-12 font-normal m-0">POSITIVE TONE</h5>
                                                 <Slider
                                                     vertical
                                                     min={-2}
                                                     max={2}
                                                     className="vertical-slider-blue"
                                                     value={Positive ? Positive : 0}
                                                     onChange={(value) => this.onChange("Positive", value)}
                                                     onAfterChange={(value) => this.onPopOverClose("Positive", value)}
                                                     tooltipVisible={false}
                                                 />
                                                 <h6 style={{marginTop: 20}}>{Positive}</h6>
                                             </div>
                                         }
                                         onVisibleChange={(value) => this.handleVisibleChange("Positive", value)}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-icon btn-toolbar dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                        onClick={() => this.openPopOver("Positive")}
                                    >
                                        <img src={PositiveImage}/>
                                    </button>
                                </Popover>

                                <div className="buttonvalue" id="positivevalue">
                                    <span
                                        // className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Positive)}`}>{Positive?.toString() || this.GetInteractionValue("Positive") || "Positive"}</span>
                                        className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Positive)}`}>Positive</span>
                                </div>
                            </div>

                            <div className="dropdown m-b-5">

                                <Popover trigger="click" visible={this.state.visible.Interesting}
                                         content={
                                             <div>
                                                 <h5 className="font-12 font-normal m-0">RELEVANCE TO ME</h5>
                                                 <Slider
                                                     vertical
                                                     min={-2}
                                                     max={2}
                                                     className="vertical-slider-blue"
                                                     value={Interesting ? Interesting : 0}
                                                     onChange={(value) => this.onChange("Interesting", value)}
                                                     onAfterChange={(value) => this.onPopOverClose("Interesting", value)}
                                                     tooltipVisible={false}
                                                 />
                                                 <h6 style={{marginTop: 20}}>{Interesting}</h6>
                                             </div>
                                         }
                                         onVisibleChange={(value) => this.handleVisibleChange("Interesting", value)}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-icon btn-toolbar dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                        onClick={() => this.openPopOver("Interesting")}
                                    >
                                        <img src={RelevantImage}/>
                                    </button>
                                </Popover>

                                <div className="buttonvalue" id="relevancevalue">
                                    <span
                                        // className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Interesting)}`}>{Interesting?.toString() || this.GetInteractionValue("Interesting") || "Interesting"}</span>
                                        className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Interesting)}`}>Interesting</span>
                                </div>
                            </div>
                        </div>

                        <div/>
                        <div onClick={() => {
                            this.setState(prevState => {
                                return {
                                    ...prevState, showComments: !prevState.showComments
                                }
                            })
                        }}>
                            <img src={commentImage} alt="comment" className="comment-image"/>
                            <span className="fullpost">
                                {getCommentsById(this.props.post.id)?.length} Comments
                            </span>
                        </div>
                    </div>

                    <div className="additional">
                        <div className="tags">

                            {post.tags ?
                                post.tags.map(tag => {
                                    if (tag.type.toLowerCase() === 'polly') {
                                        return (
                                            <div className="tag" key={tag.id}>
                                                <Link to={`/${tag.urlSlug}`}>{tag.name}</Link>
                                                <span className="btn btn-vote pointer"
                                                      onClick={() => this.openModel(tag)}
                                                      title="click to vote">Vote</span>
                                            </div>
                                        )
                                    } else if (tag.type.toLowerCase() === 'organisation' || tag.type.toLowerCase() === 'party' || tag.type.toLowerCase() === 'election') {
                                        return (
                                            <div className="secondTag" key={tag.id}>
                                            <Link to={`/${tag.urlSlug}`}>{tag.name}</Link>
                                            </div>
                                        )
                                    } else if (tag.type.toLowerCase() === 'location' || tag.type.toLowerCase() === 'topic') {
                                        return (
                                            <div className="secondTag" key={tag.id}>
                                            <a href={`/${tag.urlSlug}`}>{tag.name}</a>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <a className="title-link" key={tag.id}
                                               href={`/post_tags/${tag.id}`}> #{tag.name}</a>
                                        )
                                    }
                                })
                                : null}
                        </div>
                        {this.state.isOpen && <PostShowModel isOpen={this.state.isOpen} userData={this.state.userData}
                                                             openModel={this.openModel}/>}
                        <div className="clearfix"/>
                    </div>
                    {
                        <div className="comments">
                            <SmallCommentContainer {...this.props} comments={getCommentsById(this.props.post.id)}
                                                   showComments={this.state.showComments}
                                                   isAvailableForReply={post.canUserComment}/>
                        </div>
                    }

                </article>
            </div>
        );
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PostPreview);
